import { Theme, css } from '@emotion/react';

import RoundAvatar from '@components/common/RoundAvatar';
import SwipeableListContainer from '@components/common/SwipableListContainer';

import { IEFinderObject, IStoryChatRoomCharacter } from '@model';
import { media } from '@styles/css';

const cardContainerCSS = (theme: Theme) => css`
  display: flex;
  flex-direction: column;
  width: 40px;

  ${media.tablet} {
    width: 48px;
  }
  ${media.desktop} {
    width: 56px;
  }

  .image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    border-radius: 100px;
    position: relative;
    overflow: hidden;

    ${media.tablet} {
      width: 48px;
      height: 48px;
    }
    ${media.desktop} {
      width: 56px;
      height: 56px;
    }
  }
  .selected {
    border: 2px solid ${theme.colors.main500};
  }
  .name {
    color: ${theme.var.gray700};
    font-family: 'Apple SD Gothic Neo';
    font-size: 11px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;

    margin-top: 5px;
    text-align: center;
  }
`;

const gridContainerCSS = css`
  display: grid;
  grid-auto-flow: column;
  gap: 11px;
  padding: 6px 0px;

  ${media.tablet} {
    gap: 14px;
    padding: 8px 0px;
  }
  ${media.desktop} {
    gap: 16px;
    padding: 10px 0px;
  }
`;

type Props = {
  characterList?: IStoryChatRoomCharacter[];
  selectedCharacter?: IStoryChatRoomCharacter | null;
  onClickCharacter?: (character: IStoryChatRoomCharacter) => void;
};

const SwipeableCharacterList = ({
  characterList,
  selectedCharacter,
  onClickCharacter,
}: Props) => {
  return (
    <SwipeableListContainer className="character-container">
      <div className="grid-container" css={gridContainerCSS}>
        {characterList?.map((item, idx) => (
          <div
            css={cardContainerCSS}
            key={`info_list_${idx}`}
            onClick={() => onClickCharacter && onClickCharacter(item)}
          >
            <div
              className={`image-container ${
                selectedCharacter?.id === item.id ? 'selected' : 'non-selected'
              }`}
            >
              <RoundAvatar
                picture={item?.profile_image as IEFinderObject<'image'>}
                size={40}
              />
            </div>
            <p className="name ellipsis">{item.name}</p>
          </div>
        ))}
      </div>
    </SwipeableListContainer>
  );
};

export default SwipeableCharacterList;
